<template>
	<a-drawer :title="titleF" width="100%" @close="onClose" :visible="visibleEdit">
		<div style="display: flex;">
			<div style="width: 65%;">
				<div id="containerAdd" style="width:98%;height:100%;"></div>
			</div>
			<div style="width: 35%;">
				<a-form :form="form" layout="vertical" hideRequiredMark>
					<a-form-item v-show="false">
						<a-input v-decorator="['id']" />
					</a-form-item>
					<a-form-item label="建筑物">
						<a-select showSearch optionFilterProp="children" v-decorator="['buildingId', { rules: [{ required: true, message: '请选择建筑物' }] }]"
						 style="width:100%" @change="handleChange1" placeholder="请选择建筑物">
							<a-select-option v-for="item in buildingIdArr" :key="item.id" :value="item.id">{{ item.buildingName }}</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item label="层数">
						<a-select showSearch v-decorator="['layer', { rules: [{ required: true, message: '请选择楼层' }] }]" style="width:100%"
						 @change="handleChange1" placeholder="请选择楼层">
							<a-select-option v-for="item in layerNum" :key="item" :value="item">{{ item }}</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item label="方位">
						<a-select v-decorator="['orient', { rules: [{ required: true, message: '请选择方位' }] }]" style="width:100%"
						 placeholder="请选择方位">
							<a-select-option v-for="item in orient" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item label="每组数量">
						<a-input type="number" v-decorator="['groupNum']" placeholder="请输入每组数量" />
					</a-form-item>

					<a-form-item label="详细位置编号">
						<a-input v-decorator="['location']" style="width: 100%" placeholder="请输入详细位置" />
					</a-form-item>
					<a-form-item label="详细位置详情">
						<a-input v-decorator="['locationRemark']" style="width: 100%" placeholder="请输入详细位置" />
					</a-form-item>
					<!-- <a-form-item label="设施编号">
		                <a-input v-decorator="['facilityNum', { rules: [{ required: true, message: '请输入设施编号' }] }]" style="width: 100%"
		                    placeholder="请输入设施编号" />
		            </a-form-item> -->
					<!-- <a-form-item label="设施名称">
		                <a-input v-decorator="['facilityName', { rules: [{ required: true, message: '请输入设施名称' }] }]" style="width: 100%"
		                    placeholder="请输入设施名称" />
		            </a-form-item> -->
					<a-form-item label="设施类型">
						<a-select showSearch optionFilterProp="children" v-decorator="['facilityType', { rules: [{ required: true, message: '请选择设施类型' }] }]"
						 placeholder="请选择设施类型" style="width:100%">
							<a-select-option v-for="item in facilityTypeArr" :key="item.id" :value="item.id">{{ item.typeName }}</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item label="安装时间">
						<a-date-picker v-decorator="['instime']" @change="onChange" placeholder="请选择安装时间" />
					</a-form-item>
					<a-form-item label="配件安装时间">
						<a-date-picker v-decorator="['checkTime']" @change="onChange" placeholder="请选择配件安装时间" />
					</a-form-item>
					<!-- <a-form-item label="维修周期">
		                <a-input v-decorator="['maintCycle', { rules: [{ required: true, message: '请输入维修周期' }] }]" style="width: 100%"
		                    placeholder="请输入维修周期" />
		            </a-form-item> -->
					<a-form-item label="状态">
						<a-select v-decorator="['status']" style="width: 100%" placeholder="请选择状态">
							<a-select-option v-for="item in statusArr" :key="item.keyStr" :value="item.keyStr">
							  {{ item.value }}
							</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item label="经度">
						<a-input v-model="longitude" disabled />
					</a-form-item>
					<a-form-item label="纬度">
						<a-input v-model="latitude" disabled />
					</a-form-item>
					<a-form-item label="二维码编号">
						<a-input v-decorator="['qrcode']" placeholder="请输入二维码编号" />
					</a-form-item>
				</a-form>
				<div :style="{ position: 'absolute', left: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right' }">
					<a-button :style="{ marginRight: '8px' }" @click="onClose">取消</a-button>
					<a-button @click="submit" type="primary">提交</a-button>
				</div>
			</div>
		</div>
	</a-drawer>
</template>

<script>
	import moment from 'moment';
	import houseModel from "../MapDate.js"
	export default {
		props: {
			visibleEdit: {
				//新增抽屉是否可见
				default: false
			},
			statusArr:Array
		},
		data() {
			return {
				form: this.$form.createForm(this),
				id: null,

				layerNum: [], //层数
				campusArr: [],
				orient: [],
				facilityTypeArr: [],
				buildingIdArr: [],
				titleF: '', //抽屉标题
				//地图
				map: null,
				multilaterals: [], //绘制多边形房子
				longitude: '114.39316', //经度
				latitude: '30.48668', //纬度
				marker: null,
				stationIcon: require('@/../static/img/cll-linemap-item.png'),
			};
		},
		mounted() {
			this.handleChange1();
			/* this.$get('dictionary-detail/listByDictType/campus').then(r => {
			    this.campusArr = r.data;
			}); */
			//从字典取orient选项
			this.$get('dictionary-detail/listByDictType/orient').then(r => {
				this.orient = r.data;
			});
			this.$get('facilityType/list').then(r => {
				this.facilityTypeArr = r.data;
			});
			this.$get('building/list').then(r => {
				this.buildingIdArr = r.data;
			});
		},
		methods: {
			init() {
				//初始化表格
				this.id = null;
				this.form.resetFields();
				this.titleF = '新增消防设施';
				this.$nextTick(() => {
					this.createMap();
				})
			},
			handleChange1(value) {
				//根据建筑物获取层数
				for (var i = 0; i < this.buildingIdArr.length; i++) {
					if (value === this.buildingIdArr[i].id) {
						this.layerNum = this.buildingIdArr[i].buildingLayer.split(",");
					}
				}
			},
			onChange(date, dateString) {

			},
			submit() {
				this.form.validateFields((err, values) => {
					if (!err) {
						values.longitude = this.longitude;
						values.latitude = this.latitude;
						this.$post('facility/addOrUpdate', { ...values}).then(r => {
							this.reset();
              this.form.resetFields();
							this.$message.success('操作成功');
              this.$emit('close');
							this.onClose();
						});
					}
				});
			},
			// 设置表单回显
			setFormValues({ ...item}) {
				this.longitude = item.longitude ? item.longitude : '114.39316';
				this.latitude = item.latitude ? item.latitude : '30.48668';
				this.$nextTick(() => {
					this.createMap();
				})
				if (item.facilityOrBuilding == 2) {
					//值为2，则是楼房/街道页面的新增
					this.titleF = '新增消防设施';
					this.form.getFieldDecorator('buildingId');
					this.form.setFieldsValue({
						buildingId: item.id
					});
					this.form.getFieldDecorator('layer');
					this.form.setFieldsValue({
						layer: item.buildingLayer
					});
				} else {
					this.titleF = '修改消防设施';
					let fields = [
						'id',
						'campus',
						'buildingId',
						'layer',
						'orient',
						'groupNum',
						'location',
						'locationRemark',
						'facilityType',
						'instime',
						'checkTime',
						'status',
						'qrcode'
					];
					Object.keys(item).forEach(key => {
						if (fields.indexOf(key) !== -1) {
							this.form.getFieldDecorator(key);
							let obj = {};
							obj[key] = item[key];
							this.form.setFieldsValue(obj);
						}
					});
					if (item.instime) {
						//获取时间
						this.form.getFieldDecorator('instime'); //
						this.form.setFieldsValue({
							instime: moment(item.instime, 'YYYY-MM-DD')
						});
					}
					if (item.checkTime) {
						//获取时间
						this.form.getFieldDecorator('checkTime'); //
						this.form.setFieldsValue({
							checkTime: moment(item.checkTime, 'YYYY-MM-DD')
						});
					}
				}
			},
			//创建地图
			createMap() {
				var that = this;
				that.map = new AMap.Map('containerAdd', {
					resizeEnable: true, //是否监控地图容器尺寸变化
					zoom: 18, //初始化地图层级
					labelzIndex: 110, //地图标注显示顺序
					center: [114.39316, 30.48668] //初始化地图中心点
				});
				for (var i = 0, multilateral, len = houseModel.length; i < len; i++) {
					multilateral = new AMap.Polygon({
						path: houseModel[i].coordinate,
						fillColor: '#EFF1ED', //填充
						strokeColor: "#EFF1ED", //边框
						strokeWeight: 5
					})
					that.multilaterals.push(multilateral)
					that.multilaterals[i].setMap(that.map);
					that.multilaterals[i].on('click', function(e) {})
				}
				that.marker = new AMap.Marker({
					icon: that.stationIcon,
					position: [that.longitude, that.latitude],
					draggable: true,
					offset: new AMap.Pixel(-15, -30)
				});
				that.marker.setMap(that.map);
				that.marker.on("dragend", () => {
					var seat = that.marker.getPosition()
					that.longitude = seat.lng;
					that.latitude = seat.lat;
				})
				that.map.setFitView(that.marker[0]);
			},
			onClose() {
				// this.visibleEdit = false;
				this.$emit('close'); //不要直接更改visibleEdit
				this.form = this.$form.createForm(this);
				this.loading = false;
			},
			//重置
			reset() {
				form: this.$form.createForm(this);
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/views/web/firefacility/FireFacilityAdd.vue